import { render, staticRenderFns } from "./Hidable.vue?vue&type=template&id=80b51f3e&scoped=true&"
import script from "./Hidable.vue?vue&type=script&lang=js&"
export * from "./Hidable.vue?vue&type=script&lang=js&"
import style0 from "./Hidable.vue?vue&type=style&index=0&id=80b51f3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b51f3e",
  null
  
)

export default component.exports